import { t } from "i18next";

import styles from "./Modal.module.scss";
import { Button, Icon } from "@livingmap/hippo";

interface Props {
  closeModal: () => void;
  onDelete: () => void;
}

const DeleteImage: React.FC<Props> = ({ closeModal, onDelete }) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <h5 className={styles.title}>{t("modals.delete.title")}</h5>
        <button className={styles.closeButton} onClick={closeModal}>
          <Icon dataQA="close-icon" name="close" size={18} />
        </button>
      </div>
      <div className={styles.contentContainer}>
        <p className={styles.description}>{t("modals.delete.description")}</p>
        <div className={styles.buttonWrapper}>
          <Button
            dataQA="cancel-button"
            type="primary"
            size="regular"
            style="filled"
            text={t("btn_labels.cancel")}
            onClick={closeModal}
          />
          <Button
            dataQA="delete-button"
            type="negative"
            size="regular"
            style="filled"
            text={t("btn_labels.delete")}
            onClick={onDelete}
          />
        </div>
      </div>
    </div>
  );
};

export default DeleteImage;
